'use strict';

import type { AgencyNotificationPreference } from '../../Entities/Agency/AgencyNotificationPreference';
import { EntityCollection } from '../EntityCollection';

export class AgencyNotificationPreferenceCollection extends EntityCollection<AgencyNotificationPreference> {}
